import { Component, Inject } from '@angular/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { MAT_DIALOG_DATA } from '@angular/material/dialog'; // eslint-disable-line @typescript-eslint/no-unused-vars

import { downloadFile } from '../../shared/browser.utils';
import { CoreApiService } from '../../core-api.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { FwIconModule } from '@flywheel-io/vision';
import { DirectivesModule } from 'app/src/common/directives.module';
import { ContainerModule } from 'app/src/containers/container.module';
import { FileModule } from 'app/src/files/file.module';
import { MaterialModule } from 'app/src/material.module';
import { PipesModule } from 'app/src/shared/pipes.module';
import { SharedModule } from 'app/src/shared/shared.module';
import { JobLogComponent } from './job-log.component';

@Component({
  selector: 'job-log-dialog',
  template: `
    <h1 mat-dialog-title>Logs for {{ jobName }}</h1>
    <button data-id="modal-close-button" mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
    <div mat-dialog-content>
      <job-log [jobId]="jobId"></job-log>
    </div>
    <div class="dialog-footer">
      <div><strong>Job ID:</strong> {{ jobId }}</div>
      <div style="flex:1"></div>
      <button mat-flat-button color="primary" (click)="downloadLogs()">Download</button>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      position: relative;
    }
    .dialog-footer {
      align-items: center;
      display: flex;
      margin-top: 20px;
    }
    [mat-dialog-content] {
      border-top: 1px solid #cccccc;
      border-bottom: 1px solid #cccccc;
    }
  `],
  standalone: true,
    imports: [
      CommonModule,
      ContainerModule,
      DirectivesModule,
      FileModule,
      FormsModule,
      FwIconModule,
      MaterialModule,
      MatTabsModule,
      PipesModule,
      ReactiveFormsModule,
      SharedModule,
      JobLogComponent,
    ],
})
export class JobLogDialog {
  public jobId: string
  public jobName: string

  constructor(
    private coreApi: CoreApiService,
    @Inject(MAT_DIALOG_DATA) data: {
      jobId: string,
      jobName: string,
    },
  ) {
    this.jobId = data.jobId;
    this.jobName = data.jobName;
  }

  downloadLogs(): void {
    const filename = `${this.jobId}_logs.txt`;
    this.coreApi.jobs.logs.text(this.jobId).subscribe((response) => {
      downloadFile(filename, 'data:text/plain;charset=utf-8,' + encodeURIComponent(response));
    });
  }
}
